import { makeStylesV5 } from "..";
const TRANSPARENT = 'rgba(0,0,0,0)';
export default makeStylesV5()((theme, { open }) => ({
    root: {
        backgroundColor: open ? theme.palette.action.hover : TRANSPARENT
    }
}));
//# sourceMappingURL=styles.js.map